const OrderType = {
  UGBN: 'ungated_buy_now',
  UGSB: 'ungated_shopping_bag',
  BN: 'buy_now',
  SB: 'shopping_bag',
  DBE: 'direct_buy_exchange',
  CAT: 'categories',
} as const;

export default OrderType;
